import React, { useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
} from "react-native";
import { FontFamilies } from "@/constants/Typography";
import Images from "@/assets/images";
import { Image } from "expo-image";
import { Ionicons } from "@expo/vector-icons";

// Order arrive late brands selection (logos to be added later)
const OnboardSlide11 = () => {
  const [selectedBrands, setSelectedBrands] = useState<string[]>([]);
  const brands = [
    {
      name: "Walmart",
      image: Images.logoWalmart,
      width: 120,
    },
    {
      name: "Uber Eats",
      image: Images.logoUberEats,
      width: 120,
    },
    {
      name: "Target",
      image: Images.logoTarget,
      width: 120,
    },
    {
      name: "Amazon",
      image: Images.logoAmazon,
      width: 120,
    },
  ];

  const toggleBrand = (brandName: string) => {
    setSelectedBrands((prev) =>
      prev.includes(brandName)
        ? prev.filter((name) => name !== brandName)
        : [...prev, brandName]
    );
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Have you ever had an order arrive late?</Text>
      <Text style={styles.subtitle}>
        Pick the ones you have an order arrive late
      </Text>
      <ScrollView
        contentContainerStyle={styles.list}
        showsVerticalScrollIndicator={false}
      >
        {brands.map((brand) => {
          const isSelected = selectedBrands.includes(brand.name);
          return (
            <TouchableOpacity
              key={brand.name}
              style={[styles.row, isSelected && styles.rowSelected]}
              onPress={() => toggleBrand(brand.name)}
            >
              <Image
                source={brand.image}
                style={[styles.logoPlaceholder, { width: brand.width }]}
                contentFit="contain"
              />
              {isSelected && (
                <View style={styles.checkmark}>
                  <Ionicons name="checkmark" size={16} color="#22C55E" />
                </View>
              )}
            </TouchableOpacity>
          );
        })}
      </ScrollView>
    </View>
  );
};

export default OnboardSlide11;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    gap: 16,
    paddingTop: 32,
  },
  title: {
    fontFamily: FontFamilies.InterTight.SemiBold,
    fontSize: 32,
    lineHeight: 38,
    color: "#EBFFEE",
  },
  subtitle: {
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 16,
    color: "#EBFFEE",
    opacity: 0.7,
  },
  list: {
    width: "100%",
    gap: 12,
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FFFFFF",
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 28,
    position: "relative",
    borderWidth: 2,
    borderColor: "transparent",
  },
  rowSelected: {
    backgroundColor: "#F0F9FF",
    borderColor: "#22C55E",
  },
  logoPlaceholder: {
    height: 39,
  },
  checkmark: {
    position: "absolute",
    top: 8,
    right: 8,
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: "#CBEB6C",
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
});
